import { render, staticRenderFns } from "./EditableList.vue?vue&type=template&id=287ec464&scoped=true"
import script from "./EditableList.vue?vue&type=script&lang=js"
export * from "./EditableList.vue?vue&type=script&lang=js"
import style0 from "./EditableList.vue?vue&type=style&index=0&id=287ec464&prod&scoped=true&lang=css"
import style1 from "./EditableList.vue?vue&type=style&index=1&id=287ec464&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287ec464",
  null
  
)

export default component.exports